import ThemeContext from "components/app/Context";
import FunctionalAreas from "components/common/FunctionalAreas";
import { useContext } from "react";
import { useAppSelector } from "redux/hooks";
import { functionalAreaIdToName } from "utils/CommonFunctions";
import ToolTip from "./Tooltip";

interface Props {
  plan: any;
}

function FunctionalAreaChips(props: Props) {
  const { plan } = props;
  const functionalAreaList: any = useAppSelector((state) => state.functionalAreas.list);
  const title = plan.functionalAreaIds?.map((item: any) => functionalAreaIdToName(item, functionalAreaList)).join(", ");
  const { isMobileScreen } = useContext(ThemeContext);

  return (
    <ToolTip title={title}>
      <FunctionalAreas
        chipCount={3}
        showAbbrv={true}
        direction={isMobileScreen ? "row" : "column"}
        functionalAreaIds={plan.functionalAreaIds}
      />
    </ToolTip>
  );
}

export default FunctionalAreaChips;
